import { useState } from 'react';
import QRCode from 'react-qr-code';
import { ReclaimProofRequest } from '@reclaimprotocol/js-sdk';
import { userAgentIsIOS, userAgentIsMobile } from "./device";


 
function ReclaimDemo() {
  // State to store the verification request URL
  const [requestUrl, setRequestUrl] = useState('');
  const [proofs, setProofs] = useState([]);
  const [timestamp, setTimestamp] = useState('');
  const [amount, setAmount] = useState('');
  const [recipientId, setRecipientId] = useState('');
  const [currency, setCurrency] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('');
 
  // Define available providers
  const PROVIDERS = [
    { id: 'cf88283c-5d4d-47de-a887-710fd797c5e3', name: 'Wise' },
    { id: '0afc40bd-83b7-46f1-9027-eebc5c3fd521', name: 'Mercado Pago' },
    { id: '7db3d79b-c648-4459-9a02-283c915e15cb', name: 'Revolut' },
    { id: 'cb91eb8f-af38-47a8-96af-ae3f65d3c8bf', name: 'Venmo'}
    // Add more providers here as needed
  ];
 
  const getVerificationReq = async () => {
    if (!timestamp || !amount || !selectedProvider || !recipientId || !currency) {
      alert('Please enter timestamp, amount, recipientId and currency');
      return;
    }

    // Your credentials from the Reclaim Developer Portal
    const APP_ID = '0x7071E92D342A75684847370935B0c97fEB0600BC';
    const APP_SECRET = '0xf72dedda426c6656d0cd2fef9e1c14f06293cd3b0360fd9f8db2cbcf9758586c';
 
    const deviceType = userAgentIsMobile ? (userAgentIsIOS ? 'ios' : 'android') : 'desktop';


    // Initialize the Reclaim SDK with your credentials
    const reclaimProofRequest = await ReclaimProofRequest.init(APP_ID, APP_SECRET, selectedProvider, {
      log: false,
      acceptAiProviders: true,
      device: deviceType,
      useAppClip: deviceType !== 'desktop'
    });
 
    // Add context parameters
    reclaimProofRequest.setParams({
      timestamp: timestamp,
      amount: amount,
      recipientId: recipientId,
      currency: currency
    });
 
    // Generate the verification request URL
    const requestUrl = await reclaimProofRequest.getRequestUrl();
    console.log('Request URL:', requestUrl);
    setRequestUrl(requestUrl);
 
    // Start listening for proof submissions
    await reclaimProofRequest.startSession({
      // Called when the user successfully completes the verification
      onSuccess: (proofs) => {
        if (proofs) {
          if (typeof proofs === 'string') {
            // When using a custom callback url, the proof is returned to the callback url and we get a message instead of a proof
            console.log('SDK Message:', proofs);
            setProofs([proofs]);
          } else if (typeof proofs !== 'string') {
            // When using the default callback url, we get a proof object in the response
            if (Array.isArray(proofs)) {
              console.log(proofs)
              // when using provider with multiple proofs, we get an array of proofs
              console.log('Verification success', JSON.stringify(proofs.map(p => p.claimData.context)));
              setProofs([proofs]);
            } else {
              console.log('single proof', proofs)
              // when using provider with a single proof, we get a single proof object
              console.log('Verification success', proofs?.claimData.context);
              setProofs([proofs]);
            }
          }
        }
        // Add your success logic here, such as:
        // - Updating UI to show verification success
        // - Storing verification status
        // - Redirecting to another page
      },
      // Called if there's an error during verification
      onError: (error) => {
        console.error('Verification failed', error);
        alert('Verification failed');
        // Add your error handling logic here, such as:
        // - Showing error message to user
        // - Resetting verification state
        // - Offering retry options
      },
    });
  };
 
  return (
    <div style={{
      maxWidth: '600px',
      margin: '40px auto',
      padding: '20px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      borderRadius: '8px',
      backgroundColor: '#fff',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        color: '#333',
        textAlign: 'center',
        marginBottom: '30px'
      }}>zkp2p - reclaim provider demo</h1>

      <div style={{
        marginBottom: '20px'
      }}>
        <select
          value={selectedProvider}
          onChange={(e) => setSelectedProvider(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
        >
          <option value="">Select a provider</option>
          {PROVIDERS.map(provider => (
            <option key={provider.id} value={provider.id}>
              {provider.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          value={timestamp}
          onChange={(e) => setTimestamp(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
          placeholder="Enter timestamp eg 1743983877000"
        />

        <input
          type="text"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
          placeholder="Enter amount eg 50"
        />

        <input
          type="text"
          value={recipientId}
          onChange={(e) => setRecipientId(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
          placeholder="Enter recipientId eg 1234567890"
        />

        <input
          type="text"
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            border: '1px solid #ddd'
          }}
          placeholder="Enter currency eg USD"
        />
        
        
      </div>

      <button 
        onClick={async () => {
          await getVerificationReq();
          if (window.innerWidth < 768 && requestUrl) {
            window.location.href = requestUrl;
          }
        }}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'background-color 0.3s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
      >
        Get Verification Request
      </button>

      {requestUrl && !userAgentIsMobile && !proofs.length && (
        <div style={{ 
          margin: '30px 0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <h3 style={{ marginBottom: '15px' }}>Scan QR Code</h3>
          <QRCode value={requestUrl} />
        </div>
      )}

      {proofs && proofs.length > 0 && (
        <div style={{
          marginTop: '30px',
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '4px'
        }}>
          <h2 style={{ 
            color: '#28a745',
            marginBottom: '15px'
          }}>Verification Successful!</h2>
          <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
            backgroundColor: '#eee',
            padding: '15px',
            borderRadius: '4px'
          }}>{JSON.stringify(proofs, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
 
export default ReclaimDemo;